/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import CardWrapper from '../wrapper/card';
import CustomInput from '../reusable/input';
import ImageClass from '../../assets';
import LabelWrapper from '../wrapper/label';
import { settingViewTaskItemDetail } from '../../redux/slices/task';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { addTaskListItemfileThunk, createTaskListItemCommentThunk } from '../../redux/thunks/task';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { brand, gray, green, orange, red } from '../../theme/themePrimitives';
import { CommentOutlined, DocumentScanner, LocalActivity, VerifiedUser } from '@mui/icons-material';
import { formatDateWithTime, formatTimeUptoNow } from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

const StyledFileInput = styled('input')`
  display: none;
`;

const TaskItemDetailComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { selectedBoardTask, loaders } = useSelector((state: RootState) => state.task);
    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    // const { currentUser } = useSelector((state: RootState) => state.app);

    const [commentValue, setCommentValue] = useState('');

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    });

    const validateFileType = (file: File) => {
        const validImageTypes = [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/jpg'
        ];
        return validImageTypes.includes(file.type);
    };

    const readFileAsDataURL = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                if (reader.result) {
                    resolve(reader.result as string);
                } else {
                    reject(new Error('Failed to read file.'));
                }
            };
            reader.onerror = () => {
                reject(new Error('Error reading file.'));
            };
        });
    };
    // const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    //     if (currentUser?.id === selectedBoardTask?.created_by) {
    //         setAnchorEl(event.currentTarget);
    //     }
    // };

    // const handleClosePopover = () => {
    //     setAnchorEl(null);
    // };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            if (validateFileType(file)) {
                try {
                    const fileValue = await readFileAsDataURL(file);
                    // const fileFormat = fetchImageFormatFromBase64(fileValue);
                    const data = {
                        id: selectedBoardTask?.id as number,
                        file: fileValue,
                        filename: file.name,
                        client_id: id ? parseInt(id as string, 10) : 0
                    };
                    await dispatch(addTaskListItemfileThunk(data)).unwrap();
                } catch (error) {
                    console.error('Error processing file:', error);
                }
            } else {
                console.error('Invalid file type. Please upload a valid image.');
            }
        }
    };

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const addCommentHandler = async () => {
        try {
            const data = {
                id: selectedBoardTask?.id as number,
                comment: commentValue,
                client_id: id ? parseInt(id as string, 10) : 0
            };
            await dispatch(createTaskListItemCommentThunk(data)).unwrap();
        } catch (e) {
            // Catch errors
        }
    };

    // Handle adding a new assignee
    // const handleAddAssignee = async (newAssigneeId: number) => {
    //     try {
    //         const exist = selectedBoardTask?.members?.some((r: TaskListItemMemberObject) => (r.member_id === newAssigneeId));
    //         if (exist) {
    //             const dataForApi: AssignTaskListItemParams = {
    //                 item_id: selectedBoardTask?.id || 0,
    //                 user_id: newAssigneeId,
    //                 client_id: id ? parseInt(id as string, 10) : 0
    //             };
    //             await dispatch(removeAssignTaskListItemThunk(dataForApi)).unwrap();
    //         } else {
    //             const dataForApi: AssignTaskListItemParams = {
    //                 item_id: selectedBoardTask?.id || 0,
    //                 user_id: newAssigneeId,
    //                 client_id: id ? parseInt(id as string, 10) : 0
    //             };
    //             await dispatch(assignTaskListItemThunk(dataForApi)).unwrap();
    //             handleClosePopover();
    //         }
    //     } catch (e) {
    //         //
    //     }
    // };

    return (<Box borderTop={`1px solid ${gray[100]}`} pt={1} >
        <StyledFileInput
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept="image/*"
        // disabled={disabled}
        />
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Button variant="text" color="secondary" onClick={() => dispatch(settingViewTaskItemDetail(false))}>&larr; Back</Button>
            <Typography variant="h5" color="info">{selectedBoardTask?.title}</Typography>
            <Box
                mt={1}
                borderRadius="4px"
                width="max-content"
                padding="4px 10px"
                color={selectedBoardTask?.label_color_tag === 'danger' ? red[300] : selectedBoardTask?.label_color_tag === 'warning' ? orange[300] : selectedBoardTask?.label_color_tag === 'success' ? green[300] : brand[300]}
                bgcolor={selectedBoardTask?.label_color_tag === 'danger' ? red[100] : selectedBoardTask?.label_color_tag === 'warning' ? orange[100] : selectedBoardTask?.label_color_tag === 'success' ? green[100] : brand[100]}>
                <Typography variant="body2" fontSize="medium" fontWeight="bold">{selectedBoardTask?.label}</Typography>
            </Box>
        </Box>
        <CardWrapper>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box flex={1}>
                    <LabelWrapper label="Title" />
                    <Typography variant="subtitle2" color="textSecondary" mb={1}>{selectedBoardTask?.title}</Typography>
                    <LabelWrapper label="Label" />
                    <Typography variant="subtitle2" color="textSecondary" mb={1}>{selectedBoardTask?.label}</Typography>

                    {/* <Typography variant="h6" color="textSecondary" mb={1}>Information</Typography>
                <Typography variant="body2" color="textSecondary"><b>Task Description:</b> {selectedTaskItem?.description}</Typography>
                <Typography variant="body2" color="textSecondary"><b>Due Time:</b> {selectedTaskItem?.due_time}</Typography>
                <Typography variant="body2" color="textSecondary"><b>Due Date:</b> {selectedTaskItem?.due_date}</Typography> */}
                </Box>
                <Box flex={1}>
                    <LabelWrapper label="Due Date" />
                    <Typography variant="subtitle2" color="textSecondary" mb={1}>{selectedBoardTask?.due_date && formatDateWithTime(selectedBoardTask?.due_date)}</Typography>
                    <LabelWrapper label="Label Color Tag" />
                    <Box
                        bgcolor={selectedBoardTask?.label_color_tag === 'danger' ? red[300] : selectedBoardTask?.label_color_tag === 'warning' ? orange[300] : selectedBoardTask?.label_color_tag === 'success' ? green[300] : brand[300]}
                        borderRadius="20px" height={30} width={30}>
                    </Box>
                </Box>
                <Box flex={1}>
                    {/* <LabelWrapper label="Assigned Users" />
                    <Box display="flex" alignItems="center" gap={1} my={1}>
                        {selectedBoardTask?.members && selectedBoardTask?.members?.length > 0 && (
                            <AvatarGroup max={4}>
                                {selectedBoardTask?.members?.map((assignee: TaskListItemMemberObject) => (
                                    <Tooltip key={assignee.id} title={assignee.member_id}>
                                        <Avatar src={assignee.member_id.toString()} sx={{ width: 30, height: 30, bgcolor: gray[300], color: 'white' }}>
                                            {assignee.user.first_name.charAt(0)}
                                            {assignee.user.last_name.charAt(0)}
                                        </Avatar>
                                    </Tooltip>
                                ))}
                            </AvatarGroup>
                        )}
                        {currentUser?.id === selectedBoardTask?.created_by && <Box bgcolor={brand[300]} borderRadius="20px"
                        height={30} width={30} display="flex" justifyContent="center" alignItems="center" color="white" onClick={(e) => handleOpenPopover(e)}>
                            <Add />
                        </Box>}
                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleClosePopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        >
                            <Box p={2} width="250px">
                                {customers.filter((customer) => customer.id !== currentUser?.id && customer.is_primary !== 1).map((member) => (
                                    <Box
                                        key={member.id}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        onClick={() => handleAddAssignee(member.id)}
                                    >
                                        <Typography variant="subtitle2" color="textDisabled" fontWeight="bold" >{member.first_name} {member.last_name}</Typography>
                                        <Button
                                            variant="text"
                                            color={selectedBoardTask?.members?.some((r: TaskListItemMemberObject) => (r.member_id === member.id)) ? 'error' : 'primary'}>
                                            {selectedBoardTask?.members?.some((r: TaskListItemMemberObject) => (r.member_id === member.id)) ? 'Remove' : 'Add'}
                                        </Button>
                                    </Box>
                                ))}
                            </Box>
                        </Popover>
                    </Box> */}
                    <LabelWrapper label="Description" />
                    <Typography variant="subtitle2" color="textSecondary" mb={1}>{selectedBoardTask?.description || 'No Description Available'}</Typography>
                </Box>
            </Box>
        </CardWrapper>
        <Box display="flex" gap="10px" mt={2}>
            <CardWrapper>
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Box display="flex" alignItems="center" gap="10px"><DocumentScanner /><Typography variant="h6" color="textSecondary"> Files</Typography></Box>
                    <Button variant="outlined" onClick={handleClick} disabled={loaders.isCreating || loaders.isLoading || selectedBoardTask?.is_completed === 1}>+ Add Files</Button>
                </Box>
                <Box display="flex" flexDirection="column" gap="20px" minHeight="35vh" maxHeight="35vh" overflow="auto" pt={1}>{
                    selectedBoardTask?.files?.map((file, index) => <Box key={index}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center" gap="10px">
                                <Box
                                    maxHeight="3vh"
                                    minHeight="4vh"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    px={2}
                                    sx={{
                                        borderTopLeftRadius: '10px',
                                        borderTopRightRadius: '10px'
                                    }}>
                                    <img
                                        alt={file.file?.file_name}
                                        src={['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'tiff'].includes(file.file?.extension as string) ? `${process.env.REACT_APP_FILE_PATH}${file.file?.file_path}` : ImageClass.document}
                                        style={{
                                            width: '100%',
                                            height: '4vh',
                                            objectFit: 'contain'
                                        }}
                                    />
                                </Box>
                                <Box>
                                    {file.file?.file_name}<br />
                                    {file.file?.formatted_size}
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="body2" color="textSecondary">
                                    {file.file?.created_at ? formatTimeUptoNow(file.file?.created_at) : ''}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>)
                }</Box>
            </CardWrapper>
            <CardWrapper>
                <Box display="flex" alignItems="center" mb={1} gap="10px"><CommentOutlined /><Typography variant="h6" color="textSecondary"> Comments</Typography></Box>

                <CardWrapper><Box display="flex" flexDirection="column" minHeight="35vh" maxHeight="35vh" overflow="auto" gap="20px" pt={1}>
                    {selectedBoardTask?.comments?.map((comment, index) => <Box key={index}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center" gap="10px"><VerifiedUser />
                                <Box>
                                    <Typography variant="subtitle1" color="textSecondary">{comment.comment}</Typography>
                                    {comment?.user && <Typography variant="body2" fontSize="12px" color="textSecondary">Added by: <b>{`${comment?.user?.first_name || ''} ${comment?.user?.last_name || ''}`}</b> ({comment?.user?.role})</Typography>}
                                </Box>
                            </Box>
                            <Typography variant="body2" color="textSecondary">
                                {comment.created_at ? formatTimeUptoNow(comment.created_at) : ''}
                            </Typography>
                        </Box>
                    </Box>)
                    }
                    <div ref={messagesEndRef} />
                </Box>
                </CardWrapper>

                <Box display="flex" alignItems="center" gap="10px" mt={1}>
                    <CustomInput
                        fullWidth
                        value={commentValue}
                        onChange={(e) => setCommentValue(e.target.value)}
                        placeholder="Add a comment"
                        disabled={loaders.isCreating || loaders.isLoading || selectedBoardTask?.is_completed === 1}
                    />
                    <Button variant="contained" disabled={commentValue.trim() === '' || loaders.isCreating || loaders.isLoading || selectedBoardTask?.is_completed === 1} onClick={addCommentHandler}>
                        Send
                    </Button>
                </Box>
            </CardWrapper>
            <CardWrapper>
                <Box display="flex" alignItems="center" mb={1} gap="10px"><LocalActivity /><Typography variant="h6" color="textSecondary"> Activities</Typography></Box>
            </CardWrapper>
        </Box>
    </Box>);
};

export default TaskItemDetailComponent;